<template>
  <div id="app" style="border:1px solid transparent">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <span style="position:absolute;top:0;z-index:999"></span> -->
    <van-popup v-model="showAddr" closeable round class="addr-pop">
      <h2 class="h">請選擇收貨地址</h2>
      <ul>
        <li v-for="(item,index) in addrList" v-bind:key="index" class="addr-list" @click="selectAddr(item)">
          {{item.address}}
        </li>
      </ul>
      <span @click="goToAddr" class="block btn-addr">新建收貨地址</span>
    </van-popup>
    <loading v-show="isLoading"></loading>
  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";
  import loading from "./pages/components/loading";
  import $request from "@/service.js";
  import {
    Popup
  } from 'vant';
  export default {
    name: 'App',
    components: {
      [Popup.name]: Popup,
      loading
    },
    data() {
      return {
        showAddr: false,
        addrList: [],
        screenWidth: "",
        timer: false,
        isChrome: false

      }
    },
    computed: {
      ...mapState(["isLoading"])
    },
    updated() {
      // window.scroll(0, 0);
      console.log(this.$route.name != 'index')
      if (this.$route.name != 'index') {
        // $("#app").attr('style', '-webkit-overflow-scrolling: touch')
      }
    },
    created() {
      // this.utils.getStorage('locationInfo') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(
      //   this.utils.getStorage(
      //     'locationInfo'))));
      // //在页面刷新时将vuex里的信息保存到sessionStorage里
      // window.addEventListener("beforeunload", () => {
      //   this.utils.setStorage('locationInfo', JSON.stringify(this.$store.state))
      // })
      // if ((this.$store.state.curLongitude == '' || this.$store.state.curLatitude == '' || this.$store.state
      //     .postal_code ==
      //     ''
      //   ) && window.localStorage.getItem('sso') != null && window.localStorage.getItem('sso') != undefined) {

      //   $request.getUserAddressList().then(res => {
      //     if (res.data.errno == '0') {
      //       this.addrList = res.data.data;
      //       this.showAddr = this.addrList.length > 0 ? true : false
      //     } else {
      //       this.utils.showErrorToast(res.data.errmsg)
      //     }
      //   })
      // }
      console.log('app', 'created')
    },
    mounted() {
      // window.onresize = () => {
      //   return (() => {
      //     window.screenWidth = document.body.clientWidth
      //     this.screenWidth = window.screenWidth
      //   })()
      // }

      //   console.log('app', 'mounted')
      //   document.addEventListener('touchstart', function(event) {
      //     if (event.touches.length > 1) {
      //       event.preventDefault();
      //     }
      //   });
      //   var lastTouchEnd = 0;
      //   document.addEventListener('touchend', function(event) {
      //     var now = (new Date()).getTime();
      //     if (now - lastTouchEnd <= 300) {
      //       event.preventDefault();
      //     }
      //     lastTouchEnd = now;
      //   }, false);
      //   document.addEventListener('gesturestart', function(event) {
      //     event.preventDefault();
      //   });
      //   // this.getCartNum();
      //   document.documentElement.addEventListener('touchstart', function(event) {
      //     if (event.touches.length > 1) {
      //       event.preventDefault();
      //     }
      //   }, false);
    },
    // watch: {
    //   screenWidth(val) {
    //     // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
    //     if (!this.timer) {
    //       // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
    //       this.screenWidth = val
    //       this.timer = true
    //       let that = this
    //       setTimeout(function() {
    //         // 打印screenWidth变化的值
    //         console.log(that.screenWidth)
    //         that.timer = false
    //       }, 400)
    //     }
    //   }
    // },
    methods: {
      goToAddr() {
        this.$router.push('addressIndex');
        this.showAddr = false
      },
      selectAddr(item) {
        this.$store.state.curStoreId = item.store_id;
        this.$store.state.postal_code = item.postcode;
        this.$store.state.curLocationAddr = item.address;
        this.$store.state.curCity = item.city;
        this.$store.state.curAddrId = item.address_id;
        this.$store.state.curLongitude = item.longitude;
        this.$store.state.curLatitude = item.latitude;
        this.utils.setStorage('locationInfo', JSON.stringify(this.$store.state))
        this.showAddr = false;
        this.$router.go(0)
      },
      //获取购物车数量
      getCartNum() {
        var param = {
          "store_id": this.$store.state.curStoreId,
          "is_deliverable": 1
        }
        $request.getCartNum(param).then(res => {
          if (res.data.errno == "0") {
            this.$store.state.cartNum = res.data.data.cart.num;
            this.$store.state.amount = res.data.data.cart.amount;
            this.utils.setStorage('locationInfo', JSON.stringify(this.$store.state))
          } else {
            this.utils.showErrorToast(res.data.errmsg)
          }
        })
      }

    }
  }
</script>
<style lang="less">
  html {
    font-size: 12px;
  }

  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    color: transparent;
    background-color: transparent;
  }

  html,
  body {
    height: 100vh;
    background: #EEF1F3;

  }

  body {
    margin: 0;
    width: 100%;
    overflow-x: hidden !important;

  }

  .addr-pop {
    width: 80%;
    font-size: 14px;

    .h {
      text-align: center;
    }

    .addr-list {
      min-height: 35px;
      padding: 10px 20px;
      border-bottom: 1px solid #E8E8E8;
    }

    .btn-addr {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-top: 1px solid #E8E8E8;
      margin-top: 20px;
    }

  }



  #app {
    margin: 0 auto;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    /*    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; */
    width: 100%;
    height: 100vh;
    /* overflow-x: hidden;
    overflow-y: scroll; */
  }

  .main {
    position: absolute;
    overflow-y: scroll;
    width: 100%;
  }

  ul,
  ol {
    list-style: none;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .pa {
    position: absolute;
  }

  .pr {
    position: relative;
  }

  .block {
    display: block;
  }

  .mgt-5 {
    margin-top: 5px !important;
  }

  .inline-block {
    display: inline-block;
  }

  .inline-flex {
    display: inline-flex;
    align-items: center;
  }

  .show {
    display: inline-block;
  }

  .hide {
    display: none;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
    line-height: 0;
  }

  .clearfix:after {
    clear: both;
  }

  .fc-fff {
    color: #fff;
  }

  .fs-10 {
    font-size: 10px;
  }

  .fs-12 {
    font-size: 12px;
  }

  .fs-13 {
    font-size: 13px;
  }

  .fs-14 {
    font-size: 14px;
  }

  .fs-15 {
    font-size: 15px;
  }

  .fs-16 {
    font-size: 16px;
  }

  .fs-17 {
    font-size: 17px;
  }

  .fs-18 {
    font-size: 18px;
  }

  .fs-20 {
    font-size: 20px;
  }

  .fs-21 {
    font-size: 21px;
  }

  .fs-22 {
    font-size: 22px;
  }

  .fs-24 {
    font-size: 24px;
  }

  .fs-28 {
    font-size: 28px;
  }

  .fs-30 {
    font-size: 30px;
  }

  .fs-36 {
    font-size: 36px;
  }

  .mgt-20 {
    margin-top: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .fc-666 {
    color: #666;
  }

  .fc-999 {
    color: #999;
  }

  .fc-green {
    color: #00BC81;
  }

  .fc-ff6a17 {
    color: #FF6A17;
  }

  .fc-b9 {
    color: #B9B9B9;
  }

  .fc-black {
    color: #4B4F57;
  }

  .fc-grey {
    color: #9FA9BF;
  }

  .fc-bold {
    font-weight: bold;
  }

  .bg-fff {
    background: #fff;
  }

  .flex1 {
    flex: 1;
  }

  .text-center {
    text-align: center;
  }

  .fc-price {
    color: #ff6a17;
    font-weight: bold;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset;
  }

  .van-nav-bar__content {
    height: 48px;
  }

  .van-nav-bar .van-icon {
    color: #4B4F57;
  }

  .van-nav-bar__title {
    font-weight: bold;
    color: #4B4F57;
  }

  .van-nav-bar__left {
    padding: 0 16px;
  }

  .van-hairline--bottom::after {
    border-bottom: none;
  }

  .has-nav-cont {
    padding-top: 48px;
    box-sizing: border-box;
  }

  .van-loading {

    text-align: center;
  }

  .van-dialog__confirm,
  .van-dialog__confirm:active,
  .van-picker__confirm {
    color: #00BC81 !important;
  }

  .stock .van-dialog__confirm,
  .stock .van-dialog__confirm:active,
  .stock .van-picker__confirm {
    color: #fff !important;
  }

  /* 注册提示弹框 */
  .no-reg-pop {
    width: 345px;
    height: 30px;
    background: rgba(255, 255, 255, 0.94);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.18);
    border-radius: 15px;
    position: fixed;
    bottom: 85px;
    left: 50%;
    margin-left: -172px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .i-vip {
      width: 18px;
      height: 14px;
      vertical-align: middle;
      padding-right: 4px;
    }

    .i-close {
      width: 20px;
      height: 20px;
      border-right: 1px solid #D8D8D8;
      padding-right: 3px;
      margin-right: 8px;
      margin-left: 10px;

      img {
        margin-top: 4px;
        width: 12px;
        height: 12px;
      }
    }

    .btn-reg {
      width: 84px;
      height: 24px;
      line-height: 24px;
      background: #53CB4D;
      border-radius: 15px;
      color: #fff;
      text-align: center;
      position: absolute;
      right: 3px;
    }

  }

  @media screen and (min-width: 650px) {

    .van-nav-bar,
    .van-tabbar {
      width: 440px !important;
      left: 50% !important;
      right: 50%;
      margin-left: -220px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue